import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=014af7e8&scoped=true&"
import script from "./OrderDetail.ts?vue&type=script&lang=ts&"
export * from "./OrderDetail.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014af7e8",
  null
  
)

export default component.exports